import {environment} from "../../../environments/environment";

export function isAllowed(redirect: string | null): boolean {
  if (!redirect) {
    return false;
  }
  let redirectUrl: URL = new URL(redirect);
  return environment.allowedRoutes.some(url => url.origin == redirectUrl.origin);
}
